<template>
  <div class="app-container">
    <div v-if="$permission.canWrite()" class="navbar-group">
      <el-button type="primary" @click="extract">提取数据</el-button>
      <el-button type="primary" @click="edit">批量修改</el-button>
      <el-button type="primary" @click="save">保存</el-button>
      <el-button type="primary" @click="delRows">删除</el-button>
      <el-button type="primary" @click="find">查找</el-button>
      <el-button type="success" plain @click="onImprot">导入</el-button>
      <el-button type="success" @click="onExport">导出</el-button>
      <el-button type="primary" @click="openPrint">打印</el-button>
    </div>
    <el-table
      border
      :data="tableList"
      class="tableList"
      tooltip-effect="dark"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @row-click="addColumn"
    >
      <el-table-column type="selection" align="center" width="55" />
      <el-table-column
        prop="ProductNo"
        label="存货编码"
        align="center"
      ></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" align="center">
        <template slot-scope="{ row }">
          <span v-if="!row.isEdit">{{ row.ProductName }}</span>
          <account-select
            v-else
            v-model="row.ProductName"
            :source="DAccount"
            @select="onSelect($event, row)"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal="listTotal"
            @inputText="inputText"
            @click.native="resetFun"
            @currentPage="currentPage"
            :pageType="true"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="ProductSpec"
        label="规格"
        align="center"
      ></el-table-column>
      <el-table-column prop="RetailPrice" label="零售价" align="center" v-if="$permission.canPrice()">
        <template slot-scope="{ row }">
          <span v-if="!row.isEdit">{{ row.RetailPrice }}</span>
          <el-input v-else type="number" v-model.number="row.RetailPrice" />
        </template>
      </el-table-column>
      <el-table-column prop="TradePrice" label="批发价" align="center" v-if="$permission.canPrice()">
        <template slot-scope="{ row }">
          <span v-if="!row.isEdit">{{ row.TradePrice }}</span>
          <el-input v-else type="number" v-model.number="row.TradePrice" />
        </template>
      </el-table-column>
      <el-table-column
        prop="EmpName"
        label="最近修改人"
        align="center"
      ></el-table-column>
      <el-table-column prop="UpdateDate" label="最近修改时间" align="center">
        <template slot-scope="{ row }">
          {{ $commonJs.toDateString(row.UpdateDate) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="margin-top: 5px; float: right"
      :page-size.sync="pagingParams.pageSize"
      :page-sizes="[10, 20, 50]"
      :current-page.sync="pagingParams.pageIndex"
      layout="sizes, prev, pager, next, total, jumper"
      :total="total"
      @size-change="onPageSizeChange"
      @current-change="onPageIndexChange"
    />
    <edit-dialog ref="editDialog" @close-saved="findList"></edit-dialog>
    <extract-dialog ref="extractDialog" @close-saved="findList"></extract-dialog>
    <find-dialog ref="findDialog" @close-saved="findList"></find-dialog>
    <print-dialog
      ref="printDialog"
      :columns="columns"
      :data="columnData"
      :form-data="formData"
    ></print-dialog>
    <import-dialog ref="importDialog" @upload-success="findList" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import editDialog from "@/components/business/sales/saleprice/editDialog";
import extractDialog from "@/components/business/sales/saleprice/extractDialog";
import findDialog from "@/components/business/sales/saleprice/findDialog";
import list from "@/components/business/sales/saleprice/list";
import printDialog from "@/components/common/printDialog/printDialog";
import salePriceList from "@/data/business/sales/saleprice/edit/list.json";
import importDialog from "@/components/business/sales/saleprice/importDialog";
import accountSelect from "@/components/production/clothmanagement/cloth/select";
export default {
  name: "salePrice",
  mixins: [curdMixins],
  components: {
    list,
    extractDialog,
    findDialog,
    editDialog,
    printDialog,
    importDialog,
    accountSelect,
  },
  data() {
    return {
      api: require("@/api/sa/goodsPrice").default,
      pdApi: require("@/api/ba/product").default,
      page: false,
      total: 0,
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      tableList: [],
      multipleSelection: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      pagingParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
    };
  },
  mounted() {
    this.pdApi.list({ Property: "销售" }).then((res) => {
      this.DAccount = res.Data;
      this.initDAccount = res.Data;
      this.listTotal = res.Count;
      this.initTotal = res.Count;
    });
    this.findList();
    // this.api.list({}).then((res) => {
    //   console.log("res", res.Data);
    //   if (res.Code === 0) {
    //     // this.tableList = res.Data.map((i) => ((i.isEdit = false), i));
    //     this.tableList = res.Data.map((i) => {
    //       i.isEdit = false;
    //       i.T = 3;
    //       return i;
    //     });
    //   }
    // });
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log("multipleSelection", this.multipleSelection);
    },
    findList(param = null) {
      let params = {};
      if(param === null) params = this.pagingParams;
      else {
        params = this.$commonJs.obj.removeNullKey({ ...param, pageSize: this.pagingParams.pageSize, pageIndex: 1 });
        this.pagingParams = params;
      }
      this.api.list(params).then((res) => {
        console.log("res", res.Data);
        this.total = res.Count
        if (res.Code === 0) {
          // this.tableList = res.Data.map((i) => ((i.isEdit = false), i));
          this.tableList = res.Data.map((i) => {
            i.isEdit = false;
            i.T = 3;
            return i;
          });
        }
      });
    },
    save() {
      if (
        this.tableList.filter((i) => i.T == 0 && i.ProductId > 0).length === 0
      )
        return this.$message.warning("没有新增数据");
      let data = this.multipleSelection.filter(
        (i) => i.T === 0 && i.ProductId > 0
      );
      console.log("data",data);
      this.api.save(data).then((res) => {
        if (res.Code === 0) this.$message.success(res.Msg);
        if (res.Code === 1) this.$message.error(res.Msg);
      });
      console.log("this.$refs.getTableData()", this.$refs.list.getTableData());
    },
    // 批量修改
    edit() {
      let rows = this.multipleSelection.filter((i) => i.T != 0);
      if (rows.length == 0) {
        this.$message.warning("请选择要修改的数据");
        return;
      }
      let ids = rows.map((item) => {
        return item.GoodsPriceId;
      });
      return this.$refs.editDialog.open(ids);
    },

    // 查找
    find() {
      const row = this.tableList.filter((i) => {
        return i.T == 0&& i.ProductId > 0;
      });
      if (row.length > 0) {
        return this.$confirm("已修改是否保存", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = this.tableList.filter((i) => i.T == 0&& i.ProductId > 0);
          // data = this.$commonJs.obj.removeNullKey(data);
          this.api.save(data).then((res) => {
            if (res.Code == 0) {
              this.$refs.findDialog.open(false);
              this.$message.success(res.Msg);
            }
            if (res.Code == 1) this.$message.error(res.Msg);
          });
        });
      }
      let isUpdate = row.length > 0 ? true : false;
      return this.$refs.findDialog.open(isUpdate);

      // return this.$message.warning('未发现有数据修改')
    },
    // 提取数据
    extract() {
      this.$refs.extractDialog.openCreate();
    },

    // 导入
    onImprot() {
      this.$refs.importDialog.open();
    },
    // 导出
    onExport(params = {}) {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.$refs.list.onExport(params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.export(params).then(() => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    // 删除
    delRows() {
      let rows = this.multipleSelection.filter((i) => i.T != 0);
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => {
          return item.GoodsPriceId;
        });
        this.api.delete({ ids }).then((res) => {
          if (res.Code === 0) {
            this.$message.success(res.Msg);
            this.findList();
          } else this.$message.error(res.Msg);
        });
      });
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    addColumn(row, column) {
      if (row.index === this.tableList.length - 1 && !this.ReviewStatus) {
        this.tableList.push({
          T: 0,
          GoodsPriceId: 0,
          ProductId: 0,
          RetailPrice: 0,
          TradePrice: 0,
          UpdateEmpId: this.$commonJs.empId(),
          UpdateDate: this.$commonJs.getToday(),
          // UpdateDate: "2022-09-26T06:21:03.197Z",
          // AddUserId: 0,
          // AddTime: "2022-09-26T06:21:03.197Z",
          ProductNo: "",
          ProductName: "",
          ShortName: "",
          ProductSpec: "",
          isEdit: true,
          // EmpName: "string",
        });
      }
    },
    openPrint() {
      console.log("salePriceList", salePriceList);
      this.columnkey = salePriceList.Data.map((i) => i.tableName);
      this.columns = salePriceList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label };
        acc.push({ label: item.label, data: print });
        return acc;
      }, []);
      this.formData = salePriceList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.tableList[item.tableName],
        });
      }, []);

      this.$refs.printDialog.open();
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({ Property: "销售", pageIndex: val, pageSize: 7 })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text) {
      this.pdApi
        .list({
          Property: "销售",
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    // 选择存货名称
    onSelect(e, row) {
      console.log("e", e);
      let Product = this.tableList.map((i) => i.ProductId);
      if (Product.includes(e.ProductId))
        return this.$message.warning("产品已存在");

      row.ProductNo = e.ProductNo;
      row.ProductName = e.ProductName;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
    },
    //分页容量大小发生变化时
    onPageSizeChange(value) {
      this.pagingParams.pageSize = value;
      this.findList();
    },
    //
    onPageIndexChange(pageIndex) {
      this.pagingParams.pageIndex = pageIndex;
      this.findList();
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
